<template lang="pug">
  .MediaLegend(v-if="items")
    .MediaLegend_wrapper
      transition(:name="itemTransitionName" mode="out-in")
        p.MediaLegend_item(
          v-for="(item, index) in items"
          :key="`${index}`"
          v-if="index==currentIndex"
        ) <span>{{ item !== null ? item : 'Unnamed' }}</span>
          <span v-if="items.length >= 2" class="completion">{{ currentIndex+1 +'/'+ items.length }}</span>

</template>

<script>
export default {
  props: {
    currentIndex: {
      type: Number,
      default: 0
    },
    items: {
      type: Array
      // validator (items) {
      //   return items.every(item => typeof item === 'string')
      // }
    },
    transitionDirection: {
      type: Number,
      default: 1,
      validator (val) {
        return val === 1 || val === -1
      }
    }
  },
  computed: {
    /**
     * S'il y a au moins 1 item dans la liste
     * @return {boolean}
     */
    atLeastOneItem () {
      return this.items && this.items.length > 0
        ? this.items.filter(item => item !== '').length > 0
        : false
    },
    /**
     * nom de la transition du titre (depend de la direction du carousel)
     * @return {String} nom de la transition
     */
    itemTransitionName () {
      return this.transitionDirection > 0
        ? 'item-slide-left'
        : 'item-slide-right'
    }
  }
}
</script>

<style lang="stylus" scoped>
.MediaLegend
  max-width: 740px
  position: relative
  margin 0 auto
  height 40px
  display flex
  align-items: stretch
  justify-content: center

  @media $mq_m
    height 60px

  @media $mq_l
    height 80px

  &_wrapperrapper
    position: relative
    width 100%

  &_item
    position: absolute
    top 50%
    left 50%
    max-width 100%
    transform translate(-50%, 0%)
    text-align: center
    white-space: nowrap

    span

      animation label 0.8s $ease forwards
      display block
      transform translateY(100%)
      opacity 0

    .completion

      color #595959

    &:after

      content ''
      position: absolute
      bottom -30px
      width 80vw
      max-width: 0px
      left 50%
      height: 1px
      animation line 1s $ease forwards
      transform translateX(-50%)
      background-color $black
      opacity: .2

    @media $mq_s_only
      font-size: 12px

    &.item-slide-left-leave-to,
    &.item-slide-right-leave-to
      opacity: 0

      *:after

        transform translateY(-150%) translateX(-50%)

    // &.item-slide-left-enter
    //   transform translate(0%, -50%)

    // &.item-slide-left-leave-to
    //   transform translate(-200%, -50%)

    // &.item-slide-right-enter
    //   transform translate(-200%, -50%)

    // &.item-slide-right-leave-to
    //   transform translate(0%, -50%)

    &.item-slide-left-enter-active,
    &.item-slide-right-enter-active
      transition: all 0.8s .3s $ease

    &.item-slide-left-leave-active,
    &.item-slide-right-leave-active
      transition: all .8s $ease

  @keyframes line{
    from{ max-width: 0px }
    to{ max-width: 740px }
  }
  @keyframes label{
    from{ opacity: 0; transform: translateY(100%) }
    to{ opacity: 1; transform: translateY(0%) }
  }

</style>
